import { render, staticRenderFns } from "./DonutMetrics.vue?vue&type=template&id=4f59deea&scoped=true&"
import script from "./DonutMetrics.vue?vue&type=script&lang=js&"
export * from "./DonutMetrics.vue?vue&type=script&lang=js&"
import style0 from "./DonutMetrics.vue?vue&type=style&index=0&id=4f59deea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59deea",
  null
  
)

export default component.exports